﻿export default class PageWarningBarHandler {
    constructor() {
        // cls
        this.messageContainerHiddenCl = 'page__message--hidden';

        // els
        this.dismissBtnEl = '[data-lf-dismiss-page-warning]';
        this.messageContainerEl = '.page__message--bar';

        // cookie
        this.pageWarningDismissedCookieName = '__lfPageWarningDismissed';
        this.cookieMaxAge = 60 * 60 * 2; // two hours in seconds

        this.setupEventListeners();
    }

    setupEventListeners = () => {
        let dismissBtn = document.querySelector(this.dismissBtnEl);
        if (!dismissBtn) { // no active warning to dismiss
            return;
        }

        dismissBtn.addEventListener('click', e => {
            let container = document.querySelector(this.messageContainerEl);
            container.addEventListener('transitionend', () => {
                container.remove();
            });

            container.classList.add(this.messageContainerHiddenCl);
            this.__setDismissedCookie();
        });
    }

    __setDismissedCookie() {
        document.cookie = `${this.pageWarningDismissedCookieName}=true;path=/;max-age=${this.cookieMaxAge}`;
    }
}